import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getBillingEstimation = (startDate,endDate) => {
  return axios.get(`${BASE_URL}/api/billing/get-billing-estimation?from_date=${startDate}&to_date=${endDate}`);
};

export const getEstimateBilling = (fromDate, toDate) => {
  return axios.get(`${BASE_URL}/api/billing/estimate-billing?sFromDate=${fromDate}&sToDate=${toDate}`);
};